import BerthingStageRotator from './BerthingStageRotator'

export default BerthingStageRotator
